module.exports = __webpack_public_path__ + "assets/img/00049.57febea7.png";